export default "__VITE_ASSET__BS$bfb6u__"